import { http } from "msw";
import type { Availability, Role } from "../../api/types";
import * as viewerState from "../viewer-state";
import { decorateCreator, findViewerCreator, mockJson, runMutation } from "./shared";

interface UpdateProfileBody {
  displayName?: string;
  bio?: string;
  skills?: string[];
  location?: string;
  availability?: Availability;
  role?: Role;
}

export const meHandlers = [
  http.get("/api/me", async () => {
    const me = await findViewerCreator();
    return mockJson(decorateCreator(me));
  }),

  http.patch("/api/me", async ({ request }) => {
    const body = (await request.json()) as UpdateProfileBody;
    return runMutation(async () => {
      viewerState.updateProfileOverrides(body);
      const me = await findViewerCreator();
      return decorateCreator(me);
    });
  }),
];
